import { database } from './firebase';

interface IFirestoreQuery {
  fieldPath: string | firebase.default.firestore.FieldPath;
  opStr: firebase.default.firestore.WhereFilterOp;
  value: any;
}

export const fetchPost = async (
  type: postTypes,
  id: string
): Promise<Post | undefined> => {
  const doc = await database.collection(getCollectionName(type)).doc(id).get();
  const data = doc.data();
  return data && convertDocToPost(data, doc.id);
};

const getQueriedRef = (
  ref: firebase.default.firestore.Query<
    firebase.default.firestore.DocumentData
  >,
  queries: IFirestoreQuery[]
): firebase.default.firestore.Query<
  firebase.default.firestore.DocumentData
> => {
  if (queries.length <= 0) return ref;
  const quiredRef = ref.where(
    queries[0].fieldPath,
    queries[0].opStr,
    queries[0].value
  );
  return getQueriedRef(
    quiredRef,
    queries.filter((_, i) => i !== 0)
  );
};
const getStartAfterRef = (
  ref: firebase.default.firestore.Query<
    firebase.default.firestore.DocumentData
  >,
  lastVisible: any
): firebase.default.firestore.Query<
  firebase.default.firestore.DocumentData
> => {
  return lastVisible ? ref.startAfter(lastVisible) : ref;
};

export const fetchPosts = async (
  type: postTypes,
  limit: number,
  queries: IFirestoreQuery[] = [],
  lastVisible: any = null
): Promise<{
  docs: FirestoreDocument[];
  hasOtherPage: boolean;
}> => {
  const queryRef = database
    .collection(getCollectionName(type))
    .where('expirationDate', '>', new Date())
    .orderBy('expirationDate', 'desc');
  const orderRef = getQueriedRef(queryRef, queries).orderBy('date', 'desc');
  // .startAfter('expirationDate', new Date());
  const ref = getStartAfterRef(orderRef, lastVisible);
  const snapshot = await ref.limit(limit + 1).get();
  const docs = snapshot.docs.splice(0, limit);
  return {
    docs,
    hasOtherPage: snapshot.docs.length === limit + 1,
  };
};
const getCollectionName = (type: postTypes) => {
  return `${type}s`;
};

export const fetchOtherPosts = async (
  withoutId: string,
  type: postTypes,
  limit: number
) => {
  const queryRef = database.collection(getCollectionName(type));
  const snapshot = await queryRef.orderBy('date', 'desc').get();
  let ids = snapshot.docs
    .filter((doc) => doc.id !== withoutId)
    .map((doc) => doc.id);
  const randomizedId = emptyArray(limit).map((_) => {
    const randomizedIndex = Math.floor(Math.random() * ids.length);
    const id = ids[randomizedIndex];
    ids = ids.filter((_, i) => i !== randomizedIndex);
    return id;
  });
  const randomizedItems = snapshot.docs
    .filter((doc) => randomizedId.includes(doc.id))
    .map((doc) => convertDocToPost(doc.data(), doc.id));
  return randomizedItems;
};
export const convertDocToPost = (
  data: firebase.default.firestore.DocumentData,
  id: string
) => {
  return {
    ...data,
    id,
    date: data.date.toDate(),
  } as Post;
};

export const convertDocsToPosts = (docs: FirestoreDocument[]): Post[] => {
  return docs.map((doc) => convertDocToPost(doc.data(), doc.id));
};
const emptyArray = (length: number) => {
  return Array.apply(null, new Array(length));
};
